import * as React from 'react'
import Stack from '@mui/material/Stack'
import { PreviewBody } from './styled'
import { IReferral } from '@sales-center/common'

type Props = {
  referral: IReferral
}

export function NoReferralPreview(props: Props) {
  const { referral } = props
  return (
    <Stack>
      <PreviewBody>{referral.referralValue}</PreviewBody>
    </Stack>
  )
}
